module.exports = __webpack_public_path__ + "img/f386b15.png";